import * as React from 'react';
import { Button, UIHeading5 } from '@cian/ui-kit';
import * as styles from './PhoneButton.css';
import { InteractiveElementsWrapper } from '../InteractiveElementsWrapper';

interface IPhoneButtonProps {
  phone: string;
  collapsedPhone: string;
  phoneVisible: boolean;
  onClick(event: React.MouseEvent<HTMLButtonElement>): void;
}

export const PhoneButton: React.FC<IPhoneButtonProps> = ({ phone, collapsedPhone, phoneVisible, onClick }) => {
  return (
    <div className={styles['container']}>
      {phoneVisible ? (
        <UIHeading5 data-name="BuilderPhone">{phone}</UIHeading5>
      ) : (
        <InteractiveElementsWrapper>
          <Button data-name="BuilderPhoneButton" size="XS" theme="fill_primary" fullWidth onClick={onClick}>
            {collapsedPhone}
          </Button>
        </InteractiveElementsWrapper>
      )}
    </div>
  );
};
